module.exports = __webpack_public_path__ + "static/media/arrow-18-svgrepo-com.093e6c4a.svg";